import { z } from 'zod';

const WalletProfile_HeatmapAnalysis = z.object({
  analysis: z.string({
    description:
      'An analysis of the wallet based on the heatmap of its activity.',
  }),
  continent: z.enum(
    [
      'North America',
      'South America',
      'Europe',
      'Africa',
      'Asia',
      'Oceania',
      'Antarctica',
    ],
    {
      description: 'Likely Contentinent where the wallet is located.',
    }
  ),
  cardinalRegion: z.enum(
    [
      'North',
      'South',
      'East',
      'West',
      'Northeast',
      'Northwest',
      'Southeast',
      'Southwest',
      'Central',
    ],
    {
      description: 'Likely Cardinal Region where the wallet is located.',
    }
  ),
  peakActivity: z.string({
    description:
      'The peak activity of the wallet based on the heatmap of its activity. Short 3-5 word description.',
  }),
  entityType: z.string({
    description:
      'The type of entity that the wallet belongs to based on the heatmap of its activity.',
  }),
});

export default {
  WalletProfile_HeatmapAnalysis,
};
